module.exports = __webpack_public_path__ + "img/product_21.b23ed36.webp";